import React from 'react';
import {Link} from "react-router-dom";
import {concepts, Group, User} from "fearless-common";
import {routes} from "../../utils";
import ArrangeViaTeamsButton, {ArrangeViaTeamsProps} from "./ArrangeViaTeamsButton";
import Description from "../Description";
import {Button} from "fearless-common-ui";
import {isInAdminEnvironment} from "../../utils/env";

const minWidth = 280;

const textDarkest = 'text-darkest';

/**
 * Displays the options the user has to switch their Photo51 subscription.
 */
export default function Photo51SubscriptionSwitcher({ onSuccess, user }: { onSuccess: ArrangeViaTeamsProps['onSuccess']; user: User & { groups: Group[] } }) {
    const {
        photo51
    } = user?.subscription_per_product || {};

    return (
        <>
            {photo51
                ? <Description className={`mb-1 ${textDarkest}`}>You can change your {concepts.Photo51} {concepts.Subscription.toLowerCase()}:</Description>
                : <Description className={`mb-1 ${textDarkest}`}>You can get a {concepts.Photo51} {concepts.Subscription.toLowerCase()}:</Description>}
            <ul>
                <li className="mb-2">
                    <div className="d-flex align-items-center gap-2">
                        <div style={{ minWidth }}>
                            <Description className={`mb-0 ${textDarkest}`}>
                                {photo51?.via === 'individual' ? `Arrange via ${concepts.Group.toLowerCase()}` : `${photo51?.via === 'group' ? 'Switch' : 'Take seat in'} ${concepts.Group.toLowerCase()} ${concepts.Subscription.toLowerCase()}`}
                            </Description>
                        </div>
                        <ArrangeViaTeamsButton user={user} onSuccess={onSuccess} />
                    </div>
                </li>
                {photo51?.via !== 'individual'
                  // The option to add an individual subscription cannot be done by Fearless league employees,
                  // because it would require entering payment details, which we don't have.
                  && !isInAdminEnvironment()
                  && (
                  <li>
                      <div className="d-flex align-items-center gap-2">
                          <div style={{ minWidth }}>
                              <Description className={`mb-0 ${textDarkest}`}>
                                  Or get an individual {concepts.Subscription.toLowerCase()}
                              </Description>
                          </div>
                          <Link to={routes.getIndividualSubscription}>
                              <Button variant="outline-secondary" className={textDarkest}>Get individual subscription</Button>
                          </Link>
                      </div>
                  </li>
                    )}
            </ul>
        </>
    );
}
